import axios from 'axios';

const LOCAL_DOMAINS = ["localhost", "127.0.0.1", "www.dehn-international.com.ddev.site","www.dehn.de.ddev.site"];
let domain = "https://www.dehn.de";

if (window.location.hostname.includes("q.")) {
  domain = "https://q.dehn.de";
} else {
  domain = "https://" + window.location.hostname;
}

if (LOCAL_DOMAINS.includes(window.location.hostname)) {
  domain = "https://q.dehn.de";
}

axios.get(domain + '/de/session/token')
  .then(function (response) {
    // handle success
    axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data;
  })

export const ROISERVICE = axios.create({
  baseURL: domain + '/store/api/v1.2/roi/'
})
